import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(
  [
    <path key='0' fill='#000000' d='M12,13.5c2.6,0,4.7-2.1,4.7-4.7S14.6,4.1,12,4.1S7.3,6.2,7.3,8.8S9.3,13.5,12,13.5z' />,
    <path
      key='1'
      fill='#000000'
      d='M11.9,14.2c-3.2,0-9.5,1.6-9.5,4.8v0.8c0,1.3,1,1.9,2.3,1.9h15c1,0,1.9-0.9,1.9-1.9V19C21.5,15.8,15.1,14.2,11.9,14.2z'
    />,
    <path
      key='2'
      fill='#000000'
      d='M18.4,8c0-3.4-3-5.7-6.4-5.7C8.7,2.2,5.6,4.5,5.6,8C5.2,8.2,4.9,8.6,4.9,9.1v1.3c0,0.7,0.6,1.3,1.5,1.3h0.3
	c0.2,0,0.3-0.2,0.3-0.3V8c0-2.4,2.1-4.4,4.9-4.5S17,5.3,17,7.8c0,0,0,3.6,0,3.7c0,0.3-0.2,0.7-0.6,0.7c-0.2,0-0.6,0-0.6,0
	c-0.3,0-0.5,0.2-0.5,0.4V13c0,0.2,0.2,0.3,0.4,0.3H17c0.8,0,1.5-0.6,1.5-1.3v-0.8c0.4-0.2,0.7-0.6,0.7-1V8.9
	C19.1,8.5,18.8,8.2,18.4,8z'
    />,
  ],
  'UserRounded'
);

const UserRoundedIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(UserRoundedIcon);
